module.exports = __webpack_public_path__ + "index/img/zijin.f92d1031.png";